import { browserSupportsWebAuthn } from '@simplewebauthn/browser';

const webauthnSupported = () => browserSupportsWebAuthn();

export default webauthnSupported;
